import { Delete, Download, Edit, Groups, Person } from '@mui/icons-material';
import { Box, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import { H5, Tiny } from 'components/Typography';
import formatCurrency from 'utils/formatCurrency';
import FormatDate from 'utils/formatDate';

const columnShape = [
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        Cell: ({ value }) => {
            const date = FormatDate(value, 'dd MMM yyyy');
            const time = FormatDate(value, 'HH:mm');

            return (
                <Box sx={{ whiteSpace: 'nowrap' }}>
                    <Typography variant="body2">{date}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {time}
                    </Typography>
                </Box>
            );
        },
    },
    {
        Header: 'Invoice Info',
        accessor: 'number',
        Cell: ({ row }) => (
            <>
                <Typography variant="body2">
                    {row.original.number}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {row.original.packageName}
                </Typography>
            </>
        ),
    },
    {
        Header: 'Name',
        accessor: 'user',
        Cell: ({ row }) => {
            const { user } = row.original;

            return (
                <>
                    <H5 mb={0}>{user.fullName}</H5>
                    <Tiny my={1}>{user.email}</Tiny>
                </>
            );
        },
    },
    {
        Header: 'Profession',
        accessor: 'profession',
    },
    {
        Header: 'Total',
        accessor: 'totalPrice',
        Cell: ({ value }) => formatCurrency(value),
    },
    {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ row }) => {
            const { isGroup, status, sponsor, isFree } = row.original;
            const typeColor = isGroup ? 'error' : 'success';
            const typeLabel = isGroup ? sponsor : 'Individu';
            const TypeIcon = isGroup ? Groups : Person;
            return (
                <Box sx={{ display: 'flex', alignItems: 'start', flexDirection: 'column', gap: 1 }}>
                    <Box display="flex" gap={1}>
                        <Chip
                            label={status?.label || ''}
                            sx={{
                                backgroundColor: status?.bgColor || 'grey.200',
                                color: status?.color || 'text.primary',
                                fontWeight: 600,
                            }}
                            size="small"
                        />
                        {isFree && <Chip label="Free" color="success" size="small" />}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Chip
                            icon={<TypeIcon sx={{ fontSize: 16 }} />}
                            label={typeLabel}
                            color={typeColor}
                            variant="outlined"
                            size="small"
                            sx={{ fontWeight: 600 }}
                        />
                    </Box>
                </Box>
            );
        },
    },
    {
        Header: 'Action',
        accessor: 'id',
        Cell: ({
            row,
            handleDownload,
            handleDelete,
            handleEdit,
            isLoading,
        }) => {
            let showButtonDownload;
            let showButtonDelete;
            localStorage.getItem('role') === 'operator' ||
            localStorage.getItem('role') === 'admin'
                ? (showButtonDownload = 'block')
                : (showButtonDownload = 'none');
            localStorage.getItem('role') === 'admin'
                ? (showButtonDelete = 'block')
                : (showButtonDelete = 'none');
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <IconButton
                        onClick={() => handleDownload(row.original)}
                        sx={{ display: showButtonDownload }}
                        disabled={isLoading.value}
                    >
                        <Tooltip title="Download">
                            <Download
                                sx={{
                                    color: 'text.primary',
                                    fontSize: 18,
                                }}
                            />
                        </Tooltip>
                    </IconButton>
                    <IconButton
                        onClick={() => handleDelete(row.original)}
                        sx={{ display: showButtonDelete }}
                    >
                        <Tooltip title="Delete">
                            <Delete
                                sx={{
                                    color: 'text.disabled',
                                    fontSize: 18,
                                }}
                            />
                        </Tooltip>
                    </IconButton>
                    <IconButton
                        onClick={() => handleEdit(row.original)}
                        sx={{ display: showButtonDelete }}
                    >
                        <Tooltip title="Edit">
                            <Edit
                                sx={{
                                    color: 'text.disabled',
                                    fontSize: 18,
                                }}
                            />
                        </Tooltip>
                    </IconButton>
                </Box>
            );
        },
    },
];
export default columnShape;
